import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const FacebookSquareIcon = ({ color = '#B5BCBD', size = '40', ...props }) => (
  <svg
    width={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26 0c1.653 0 3.066.587 4.24 1.76C31.413 2.934 32 4.347 32 6v20c0 1.653-.587 3.066-1.76 4.24C29.066 31.413 27.653 32 26 32h-3.917V19.604h4.146l.623-4.833h-4.77v-3.08c0-.778.163-1.362.49-1.75.325-.39.96-.584 1.905-.584l2.54-.02V5.02c-.874-.124-2.11-.187-3.707-.187-1.89 0-3.4.556-4.53 1.667-1.13 1.11-1.698 2.68-1.698 4.708v3.563h-4.166v4.835h4.166V32H6c-1.653 0-3.066-.587-4.24-1.76C.587 29.066 0 27.653 0 26V6c0-1.653.587-3.066 1.76-4.24C2.934.587 4.347 0 6 0h20z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

FacebookSquareIcon.propTypes = propTypes;

export default FacebookSquareIcon;
